 <template lang="pug">
  .container-fluid
    vm-col.top(vm-justify="center", vm-align="center" vm-w=12)
      span {{ $t('permissions.all') }}
        toogle(masterSwitch @enableAll="setActiveFlag" @disableAll="setActiveFlag")
    vm-col(vm-w="3")
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.dashboard') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('dashboard.index')" @delete="removePermissions('dashboard.index')")
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.search_bar') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('search_bar.index')" @delete="removePermissions('search_bar.index')")
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.reports') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('reports.index')" @delete="removePermissions('reports.index')")
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.customers') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.customers_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_customers_index" :isDisabled="enable_customers_index" @permission="permission('customers.index')" @delete="removePermissions('customers.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.customers_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('customers.store', 'customers.index')" @delete="removePermissions('customers.store', 'customers.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.customers_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('customers.destroy', 'customers.index')" @delete="removePermissions('customers.destroy', 'customers.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.employees') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.employees_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_employees_index" :isDisabled="enable_employees_index" @permission="permission('employees.index')" @delete="removePermissions('employees.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.employees_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('employees.store', 'employees.index')" @delete="removePermissions('employees.store', 'employees.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.employees_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('employees.destroy', 'employees.index')" @delete="removePermissions('employees.destroy', 'employees.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.select_employees') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('select_employees.store', 'employees.index')" @delete="removePermissions('select_employees.store', 'select_employees.update')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.contacts') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.select_contacts') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('select_contacts.store', 'employees.index')" @delete="removePermissions('select_contacts.store', 'select_contacts.update')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.to_quote') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.to_quotes_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active"  :parent="enable_to_quotes_index" :isDisabled="enable_to_quotes_index" @permission="permission('to_quotes.index')" @delete="removePermissions('to_quotes.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.projects_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('projects.store', 'to_quotes.index')" @delete="removePermissions('projects.store', 'to_quotes.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.projects_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('projects.destroy', 'to_quotes.index')" @delete="removePermissions('projects.destroy', 'to_quotes.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.docs_reciveds_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_docs_reciveds_index" :isDisabled="enable_docs_reciveds_index" @permission="permission('docs_reciveds.index')" @delete="removePermissions('docs_reciveds.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.docs_reciveds_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('docs_reciveds.update', 'docs_reciveds.index')" @delete="removePermissions('docs_reciveds.update', 'docs_reciveds.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.quotations_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('quotations.update', 'to_quotes.index')" @delete="removePermissions('quotations.update', 'to_quotes.index')" )
    vm-col(vm-w="3")
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.revissions') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.revissions_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_revisions_index" :isDisabled="enable_revisions_index" @permission="permission('revisions.index')" @delete="removePermissions('revisions.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.revissions_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('revisions.store', 'revisions.index')" @delete="removePermissions('revisions.store', 'revisions.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.revissions_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('revisions.update', 'revisions.index')" @delete="removePermissions('revisions.update', 'revisions.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.quoted') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.quoteds_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_quoteds_index" :isDisabled="enable_quoteds_index" @permission="permission('quoteds.index')" @delete="removePermissions('quoteds.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.project_details_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_project_details_index" :isDisabled="enable_project_details_index" @permission="permission('project_details.index')" @delete="removePermissions('project_details.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.project_details_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('project_details.store', 'project_details.index')" @delete="removePermissions('project_details.store', 'project_details.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.project_details_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('project_details.update', 'project_details.index')" @delete="removePermissions('project_details.update', 'project_details.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.project_details_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('project_details.destroy', 'project_details.index')" @delete="removePermissions('project_details.destroy', 'project_details.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.quotation_files_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('quotation_files.index', 'quoteds.index')" @delete="removePermissions('quotation_files.index', 'quoteds.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.quotation_files_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('quotation_files.store', 'quoteds.index')" @delete="removePermissions('quotation_files.store', 'quoteds.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.amount_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('amount.update', 'quoteds.index')" @delete="removePermissions('amount.update', 'quoteds.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.status_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('status.store', 'quoteds.index')" @delete="removePermissions('status.store', 'quoteds.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.rfis') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.rfis_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_rfis_index" :isDisabled="enable_rfis_index" @permission="permission('rfis.index')" @delete="removePermissions('rfis.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.rfis_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('rfis.store', 'rfis.index')" @delete="removePermissions('rfis.store', 'rfis.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.rfis_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('rfis.update', 'rfis.index')" @delete="removePermissions('rfis.update', 'rfis.index')" )
    vm-col(vm-w="3")
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.in_orders') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.in_order_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_in_orders_index" :isDisabled="enable_in_orders_index" @permission="permission('in_orders.index')" @delete="removePermissions('in_orders.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.scope_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_scopes_index" :isDisabled="enable_scopes_index" @permission="permission('scopes.index')" @delete="removePermissions('scopes.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.scope_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('scopes.update', 'scopes.index')" @delete="removePermissions('scopes.update', 'scopes.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.submittal_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_submittals_index" :isDisabled="enable_submittals_index" @permission="permission('submittals.index')" @delete="removePermissions('submittals.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.submittal_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('submittals.store', 'submittals.index')" @delete="removePermissions('submittals.store', 'submittals.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.submittal_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('submittals.destroy', 'submittals.index')" @delete="removePermissions('submittals.destroy', 'submittals.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.submittal_details_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_submittal_details_index" :isDisabled="enable_submittal_details_index" @permission="permission('submittal_details.index')" @delete="removePermissions('submittal_details.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.submittal_details_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('submittal_details.store', 'submittal_details.index')" @delete="removePermissions('submittal_details.store', 'submittal_details.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.submittal_details_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('submittal_details.destroy', 'submittal_details.index')" @delete="removePermissions('submittal_details.destroy', 'submittal_details.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.gallery_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_gallerys_index" :isDisabled="enable_gallerys_index" @permission="permission('gallerys.index')" @delete="removePermissions('gallerys.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.gallery_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('gallerys.store', 'gallerys.index')" @delete="removePermissions('gallerys.store', 'gallerys.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.gallery_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('gallerys.destroy', 'gallerys.index')" @delete="removePermissions('gallerys.destroy', 'gallerys.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.field_used_drawings_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_field_used_drawings_index" :isDisabled="enable_field_used_drawings_index" @permission="permission('field_used_drawings.index')" @delete="removePermissions('field_used_drawings.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.field_used_drawings_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('field_used_drawings.store', 'field_used_drawings.index')" @delete="removePermissions('field_used_drawings.store', 'field_used_drawings.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.field_used_drawings_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('field_used_drawings.update', 'field_used_drawings.index')" @delete="removePermissions('field_used_drawings.update', 'field_used_drawings.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.field_used_drawings_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('field_used_drawings.destroy', 'field_used_drawings.index')" @delete="removePermissions('field_used_drawings.destroy', 'field_used_drawings.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.delivery_deadline_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('delivery_deadlines.update', 'in_orders.index')" @delete="removePermissions('delivery_deadlines.update', 'in_orders.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.finish_projects_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('finish_projects.store', 'in_orders.index')" @delete="removePermissions('finish_projects.store', 'in_orders.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.shipments') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.shipments_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_shipments_index" :isDisabled="enable_shipments_index" @permission="permission('shipments.index')" @delete="removePermissions('shipments.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.shipments_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('shipments.store', 'shipments.index')" @delete="removePermissions('shipments.store', 'shipments.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.shipments_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('shipments.update', 'shipments.index')" @delete="removePermissions('shipments.update', 'shipments.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.claims_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_claims_index" :isDisabled="enable_claims_index" @permission="permission('claims.index')" @delete="removePermissions('claims.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.claims_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('claims.store', 'claims.index')" @delete="removePermissions('claims.store', 'claims.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.claims_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('claims.update', 'claims.index')" @delete="removePermissions('claims.update', 'claims.index')" )
    vm-col(vm-w="3")
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.categories') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.categories_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_categories_index" :isDisabled="enable_categories_index" @permission="permission('categories.index')" @delete="removePermissions('categories.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.categories_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('categories.store', 'categories.index')" @delete="removePermissions('categories.store', 'categories.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.categories_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('categories.destroy', 'categories.index')" @delete="removePermissions('categories.destroy', 'categories.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.additionals') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.additionals_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_additionals_index" :isDisabled="enable_additionals_index" @permission="permission('additionals.index')" @delete="removePermissions('additionals.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.additionals_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('additionals.store', 'additionals.index')" @delete="removePermissions('additionals.store', 'additionals.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.payments') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.payments_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_payments_index" :isDisabled="enable_payments_index" @permission="permission('payments.index')" @delete="removePermissions('payments.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.payments_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('payments.store', 'payments.index')" @delete="removePermissions('payments.store', 'payments.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.payments_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('payments.update', 'payments.index')" @delete="removePermissions('payments.update', 'payments.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.finisheds') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.finisheds_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('finisheds.index')" @delete="removePermissions('finisheds.index')" )
      .group
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col.titles(vm-justify="center", vm-align="center", vm-w=12)
            span {{ $t('strings.users') }}
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.users_index') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" :parent="enable_users_index" :isDisabled="enable_users_index" @permission="permission('users.index')" @delete="removePermissions('users.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.users_store') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('users.store', 'users.index')" @delete="removePermissions('users.store', 'users.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.users_update') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('users.update', 'users.index')" @delete="removePermissions('users.update', 'users.index')" )
        vm-row.separador(vm-type="flex" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=9)
            span {{ $t('permissions.users_destroy') }}:
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
            toogle(:flag="active" @permission="permission('users.destroy', 'users.index')" @delete="removePermissions('users.destroy', 'users.index')" )

</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Users')

export default {
  name: 'AddPermissionsCano',
  components: {
    toogle: () => import('@/components/aditionals/Toogle.vue')
  },
  data: () => ({
    step: 1,
    active: false,
    enable_customers_index: false,
    enable_to_quotes_index: false,
    enable_docs_reciveds_index: false,
    enable_categories_index: false,
    enable_revisions_index: false,
    enable_quoteds_index: false,
    enable_project_details_index: false,
    enable_rfis_index: false,
    enable_in_orders_index: false,
    enable_scopes_index: false,
    enable_gallerys_index: false,
    enable_shipments_index: false,
    enable_claims_index: false,
    enable_additionals_index: false,
    enable_payments_index: false,
    enable_users_index: false
  }),
  methods: {
    ...mapActions([
      'addPermissions',
      'deletePermissions',
      'addUser',
      'addAllPermissions'
    ]),
    async permission (data, parentIndex) {
      if (!parentIndex) {
        this.addPermissions(data)
      } else {
        switch (parentIndex) {
          case 'customers.index':
            this.enable_customers_index = true
            break
          case 'employees.index':
            this.enable_employees_index = true
            break
          case 'to_quotes.index':
            this.enable_to_quotes_index = true
            break
          case 'docs_reciveds.index':
            this.enable_docs_reciveds_index = true
            break
          case 'categories.index':
            this.enable_categories_index = true
            break
          case 'revisions.index':
            this.enable_revisions_index = true
            break
          case 'quoteds.index':
            this.enable_quoteds_index = true
            break
          case 'project_details.index':
            this.enable_project_details_index = true
            break
          case 'rfis.index':
            this.enable_rfis_index = true
            break
          case 'in_orders.index':
            this.enable_in_orders_index = true
            break
          case 'scopes.index':
            this.enable_scopes_index = true
            break
          case 'submittals.index':
            this.enable_submittals_index = true
            break
          case 'submittal_details.index':
            this.enable_submittals_index = true
            break
          case 'gallerys.index':
            this.enable_gallerys_index = true
            break
          case 'field_used_drawings.index':
            this.field_used_drawings_index = true
            break
          case 'shipments.index':
            this.enable_shipments_index = true
            break
          case 'claims.index':
            this.enable_claims_index = true
            break
          case 'additionals.index':
            this.enable_additionals_index = true
            break
          case 'payments.index':
            this.enable_payments_index = true
            break
          case 'users.index':
            this.enable_users_index = true
            break
        }
        this.addPermissions(parentIndex)
        this.addPermissions(data)
      }
    },
    async removePermissions (data, parentIndex) {
      if (!parentIndex) {
        this.deletePermissions(data)
      } else {
        switch (parentIndex) {
          case 'customers.index':
            this.enable_customers_index = false
            break
          case 'employees.index':
            this.enable_employees_index = true
            break
          case 'to_quotes.index':
            this.enable_to_quotes_index = false
            break
          case 'docs_reciveds.index':
            this.enable_docs_reciveds_index = false
            break
          case 'categories.index':
            this.enable_categories_index = false
            break
          case 'revisions.index':
            this.enable_revisions_index = false
            break
          case 'quoteds.index':
            this.enable_quoteds_index = false
            break
          case 'project_details.index':
            this.enable_project_details_index = false
            break
          case 'rfis.index':
            this.enable_rfis_index = false
            break
          case 'in_orders.index':
            this.enable_in_orders_index = false
            break
          case 'scopes.index':
            this.enable_scopes_index = false
            break
          case 'submittals.index':
            this.enable_submittals_index = false
            break
          case 'submittal_details.index':
            this.enable_submittals_index = false
            break
          case 'gallerys.index':
            this.enable_gallerys_index = false
            break
          case 'field_used_drawings.index':
            this.field_used_drawings_index = true
            break
          case 'shipments.index':
            this.enable_shipments_index = false
            break
          case 'claims.index':
            this.enable_claims_index = false
            break
          case 'additionals.index':
            this.enable_additionals_index = false
            break
          case 'payments.index':
            this.enable_payments_index = false
            break
          case 'users.index':
            this.enable_users_index = false
            break
        }
        this.deletePermissions(data)
      }
    },
    setActiveFlag () {
      this.active = !this.active
      if (this.active) {
        this.addAllPermissions(true)
      } else {
        this.addAllPermissions(false)
      }
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .admin {
    height: 25rem;
    text-align: center;
    background: white;
    padding: 20px;
  }
  .img{
    height: 70%;
  }
  .permissions {
    height: calc(120vh - 110px);
    overflow-y: auto;
  }
  .card {
    padding: 20px;
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
  .separador {
    margin: 15px;
  }
  .group {
    padding: 10px 30px 10px 10px;
    margin: 18px;
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
  .titles {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 18px;
  }
  .top {
    text-align: center;
    padding: 5px;
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
</style>
